import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

const BlogCategoryFilter = ({ categories, selectedCategory, onCategoryChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleCategorySelect = (categoryId) => {
    onCategoryChange(categoryId);
    setIsOpen(false);
  };

  const getSelectedCategoryName = () => {
    if (!selectedCategory) return 'All Posts';
    const category = categories.find(cat => cat.id === selectedCategory);
    return category ? category.name : 'All Posts';
  };

  if (categories.length === 0) {
    return null;
  }

  return (
    <div className="blog-category-filter">
      <div className="blog-category-filter__dropdown">
        <button
          className="blog-category-filter__trigger"
          onClick={() => setIsOpen(!isOpen)}
        >
          <span>{getSelectedCategoryName()}</span>
          <FontAwesomeIcon 
            icon={faChevronDown} 
            className={`blog-category-filter__chevron ${isOpen ? 'open' : ''}`}
          />
        </button>
        
        {isOpen && (
          <div className="blog-category-filter__menu">
            <button
              className={`blog-category-filter__option ${!selectedCategory ? 'active' : ''}`}
              onClick={() => handleCategorySelect(null)}
            >
              All Posts
            </button>
            
            {categories.map((category) => (
              <button
                key={category.id}
                className={`blog-category-filter__option ${selectedCategory === category.id ? 'active' : ''}`}
                onClick={() => handleCategorySelect(category.id)}
              >
                {category.name}
                <span className="blog-category-filter__count">
                  ({category.posts_count || 0})
                </span>
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogCategoryFilter; 